<template>
    <div class="pt-40 ">
        <h2 class="text-24 fw-600 "> {{ $t('curriculum.title') }}</h2>
        <div class="mt-10">
            <div class="accordion" id="accordionExample">
                <div class="accordion-item" v-for="chapter, i in courseItem?.chapters" :key="chapter.uuid">
                    <h2 class="accordion-header" :id="`headingTwo${i}`">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            :data-bs-target="`#collapseTwo${i}`" aria-expanded="false"
                            :aria-controls="`collapseTwo${i}`">
                            <div class="flex-column  align-items-center btn-title">
                                {{ chapter.title }}
                                <div class="btn-time"> {{ chapter.content.length }} {{ $t('lectures') }} |
                                    {{ chapter['time_estimate_readable'] }} </div>
                            </div>
                        </button>
                    </h2>

                    <div :id="`collapseTwo${i}`" class="accordion-collapse collapse" :aria-labelledby="`headingTwo${i}`"
                        data-bs-parent="#accordionExample">
                        <div class="accordion-body">
                            <div class="sidebar__item">
                                <div>
                                    <div class="sidebar-checkbox__item d-flex justify-content-between align-items-center mt-2 mb-4"
                                        v-for="content in chapter?.content" :key="content.id">

                                        <div v-if="content.type === 'Article'"
                                            class="d-flex align-items-center justify-content-between w-100">
                                            <div class="form-checkbox d-flex gap-3 align-">
                                                <!-- <div class="list-icon bg-black"></div> -->
                                                <div>
                                                    <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                                                        height="24" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="#09445D" stroke-linecap="round"
                                                            stroke-linejoin="round" stroke-width="2"
                                                            d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z" />
                                                    </svg>
                                                </div>
                                                <p>{{ content.title }}</p>
                                            </div>
                                            <p>{{ content['time_estimate_readable'] }}</p>
                                        </div>

                                        <div v-if="content.type === 'Lecture'"
                                            class="d-flex align-items-center justify-content-between w-100">

                                            <div class="form-checkbox d-flex gap-3 align-">
                                                <!-- <div class="list-icon bg-black"></div> -->
                                                <div>
                                                    <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                                                        height="24" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="#09445D" stroke-linecap="round"
                                                            stroke-linejoin="round" stroke-width="2"
                                                            d="M19 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm0 0-4 4m5 0H4m1 0 4-4m1 4 4-4m-4 7v6l4-3-4-3Z" />
                                                    </svg>
                                                </div>
                                                <p>{{ content.title }}</p>
                                            </div>
                                            <div class="d-flex gap-2">
                                                <!-- <div class="play-icon" @click="showLectureVideo(content.id)"
                                                    v-if="content.is_demo === 1">
                                                    <span data-bs-toggle="modal" data-bs-target="#exampleModal">
                                                        <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                            aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                            width="24" height="24" fill="#fff" viewBox="0 0 24 24">
                                                            <path fill-rule="evenodd"
                                                                d="M8.6 5.2A1 1 0 0 0 7 6v12a1 1 0 0 0 1.6.8l8-6a1 1 0 0 0 0-1.6l-8-6Z"
                                                                clip-rule="evenodd" />
                                                        </svg>
                                                    </span>
                                                </div> -->
                                                <div class="play-icon" @click="showLectureVideo(content.id)"
                                                    v-if="content.is_demo === 1">
                                                    <span @click="openModal">
                                                        <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                            aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                                                            width="24" height="24" fill="#fff" viewBox="0 0 24 24">
                                                            <path fill-rule="evenodd"
                                                                d="M8.6 5.2A1 1 0 0 0 7 6v12a1 1 0 0 0 1.6.8l8-6a1 1 0 0 0 0-1.6l-8-6Z"
                                                                clip-rule="evenodd" />
                                                        </svg>
                                                    </span>
                                                </div>
                                                <p>{{ content['time_estimate_readable'] }}</p>
                                            </div>
                                        </div>

                                        <div v-if="content.type === 'Quiz'"
                                            class="mt-3 d-flex align-items-baseline justify-content-between w-100">
                                            <div class="form-checkbox d-flex gap-3 align-">
                                                <!-- <div class="list-icon bg-black"></div> -->
                                                <div>
                                                    <svg class="w-6 h-6 text-gray-800 dark:text-white"
                                                        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24"
                                                        height="24" fill="none" viewBox="0 0 24 24">
                                                        <path stroke="#09445D" stroke-linecap="round"
                                                            stroke-linejoin="round" stroke-width="2"
                                                            d="M9.529 9.988a2.502 2.502 0 1 1 5 .191A2.441 2.441 0 0 1 12 12.582V14m-.01 3.008H12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                    </svg>
                                                </div>
                                                <p>{{ content.title }}</p>
                                            </div>
                                            <div>
                                                <p>{{ content['time_estimate_readable'] }}</p>
                                                <p class="mt-2">{{ content.options.question_count }} {{ $t('questions')
                                                    }} </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal -->
    <div v-if="isModalOpen" class="modal fade show d-block" tabindex="-1" @click="handleOutsideClick">
        <div class="modal-dialog modal-dialog-centered" @click.stop>
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" aria-label="Close" @click="closeModal">
                        <svg class="w-6 h-6 text-gray-800 dark:text-white" xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18 17.94 6M18 18 6.06 6" />
                        </svg>
                    </button>
                </div>
                <div class="modal-body">
                    <div style="height: 60vh;" ref="videoContainer">
                        <div class="video-container" style="height: inherit;" v-html="videoSrc"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" ref="modal"
        @click="handleOutsideClick"> 
        <div class="modal-dialog modal-dialog-centered" @click.stop>
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" data-bs-dismiss="modal" aria-label="Close" @click="closeModal">
                        <svg class="w-6 h-6 text-gray-800 dark:text-white" xmlns="http://www.w3.org/2000/svg" width="24"
                            height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18 17.94 6M18 18 6.06 6" />
                        </svg>
                    </button>
                </div>
                <div class="modal-body">
                    <div style="height: 60vh;" ref="videoContainer">
                        <div class="video-container" style="height: inherit;" v-html="videoSrc"></div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

</template>
<script>
import { getCourseDemo } from '@/Services/api/CoursesService';

export default {
    data() {
        return {
            video: null,
            modal: null,
            videoSrc: null,
            isModalOpen: false,
        }
    },
    computed: {
        courseItem() {
            return this.$store.getters.courseItem;
        },
    },
    methods: {
        openModal() {
            this.isModalOpen = true;
            document.body.classList.add('modal-open');
        },
        closeModal() {
            this.isModalOpen = false;
            document.body.classList.remove('modal-open');
        },
        async showLectureVideo(id) {
            let response = await getCourseDemo(id);
            this.videoSrc = response.data.embed_html;
            this.openModal();
        },
        handleOutsideClick(event) {
            if (event.target.classList.contains("modal")) {
                this.closeModal();
            }
        },
        // closeModal() {
        //     document.activeElement.blur(); 
        //     this.videoSrc = null
        //     // Check if the click was outside the video
        //     //   if (this.video && !this.video.contains(event.target)) {
        //     //     this.video.pause();
        //     //     this.video.currentTime = 0; // Optionally reset the video
        //     //   }
        // },
        // handleOutsideClick(event) {
        //     // Check if the click was outside the video container
        //     if (!this.$refs.videoContainer.contains(event.target)) {
        //         this.closeModal();
        //     }
        // }
    },
    mounted() {
        // const modalElement = document.getElementById("exampleModal");
        //     modalElement.addEventListener("shown.bs.modal", () => {
        //     document.activeElement.blur();
        // });
    },
    beforeDestroy() {
    },
}
</script>
<style lang="scss" scoped>
.modal {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-open {
    overflow: hidden;
}

.modal:focus {
    outline: none !important;
}

.modal-dialog {
    max-width: 60%;
}

.modal-content {
    background: #fff;
    border: 0;
}

.modal-header {
    border-bottom: 0;
    padding: 0px 15px;
    padding-top: 20px;

    button {
        background: #09445d;
        padding: 4px;
        border-radius: 5px;
    }
}

.list-icon {
    width: 8px;
    height: 8px;
    border-radius: 3px;
}

.form-checkbox label {
    font-size: 16px !important;
}

.play-icon {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #09445D;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    svg {
        margin-right: -3px;
        margin-bottom: 1px;
    }

    transition: 0.2s ease-in-out;

    &:hover {
        background: #31c114;
    }
}

.sidebar-checkbox__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
}

h2 {
    color: #09445D;
    line-height: 140%;
}

.accordion-item {
    padding: 18px;
    background: #F9FBFB;
    -webkit-box-shadow: none;
    box-shadow: none;
}

.accordion-body {
    border-top: 1px solid #E6E6E6;
}

.accordion-button {
    padding: 0 !important
}

.accordion-button::after {
    content: '🔒';
    color: gray;
    font-size: 20px;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 8px;
    background: none;
    width: 30px;
    height: 30px;
}

:lang(ar) {
    .accordion-button::after {
        margin-left: 0;
        margin-right: auto;
    }
}

:lang(en) {
    .accordion-button::after {
        margin-right: 0;
        margin-left: auto;
    }
}

.accordion-button:not(.collapsed)::after {
    content: '-';
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transform: none;
    -ms-transform: none;
    transform: none;
    color: #fff;
    background: var(--main, #206387);
}

.accordion-button:not(.collapsed) {
    background-color: transparent;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}

.accordion-item {
    margin-bottom: 24px;
    border-radius: 10px;
    background: var(--color-gray-10, #FFF);
    -webkit-box-shadow: 0px 5px 16px 0px rgba(8, 15, 52, 0.06);
    box-shadow: 0px 5px 16px 0px rgba(8, 15, 52, 0.06);
    border: none !important
}

.accordion-button:focus {
    -webkit-box-shadow: none;
    box-shadow: none;
}

.accordion-button {
    .btn-title {
        color: var(--Primary-600, #09445D);
        font-size: 16px;
        font-weight: 500;

        &:lang(en) {
            text-align: left;
        }

        &:lang(ar) {
            text-align: right;
        }
    }

    .btn-time {
        color: var(--Neutral-500, #999);
        font-size: 16px;
        font-weight: 400;

        &:lang(en) {
            text-align: left;
        }

        &:lang(ar) {
            text-align: right;
        }
    }

}

ul li {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;

    span {
        color: var(--Neutral-700, #4D4D4D);
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
    }
}

input[type="checkbox"] {
    width: 20px;
    height: 20px;
}

@media (max-width: 767.9px) {
    .modal-dialog {
        max-width: 90%;
    }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
    .modal-dialog {
        max-width: 80%;
    }
}
</style>